var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-pretender",on:{"click":_vm.print}},[_c('i',{staticClass:"far fa-exclamation-circle"}),_vm._v(" "),_c('span',{staticClass:"pl-2"},[_vm._v("Press Cmd/Ctrl+P to print/save as PDF.")])])
}
var staticRenderFns = []

export { render, staticRenderFns }